export default __webpack_public_path__ + "static/deccan-0b4c273961dc715aa8ced9496a740e8b.png";